export const set = ({ commit, dispatch, state, getters }, assignmentReference) => {
  return new Promise((resolve) => {
    commit('SET_ASSIGNMENT_REFERENCE', assignmentReference)
    resolve()
  })
}

export const empty = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_ASSIGNMENT_REFERENCE', undefined)
    resolve()
  })
}
